<template>
  <section class="bulk-imports-hub">
    <header class="bulk-imports-hub__hero">
      <div>
        <p class="bulk-imports-hub__eyebrow">Operación</p>
        <h1 class="bulk-imports-hub__title">Cargas masivas</h1>
        <p class="bulk-imports-hub__copy">
          Centraliza las importaciones operativas y descarga sus plantillas desde un único lugar.
        </p>
      </div>
    </header>

    <section class="bulk-imports-hub__card">
      <div class="bulk-imports-hub__card-head">
        <div>
          <p class="bulk-imports-hub__label">Disponible</p>
          <h2 class="bulk-imports-hub__item-title">Cuentas bancarias</h2>
          <p class="bulk-imports-hub__item-copy">
            Importa cuentas bancarias desde CSV con validación previa, preview por fila y confirmación explícita.
          </p>
        </div>

        <div class="bulk-imports-hub__actions">
          <button
            type="button"
            class="bulk-imports-hub__ghost"
            :disabled="isDownloadingTemplate"
            @click="downloadTemplate"
          >
            {{ isDownloadingTemplate ? 'Descargando...' : 'Descargar plantilla' }}
          </button>
          <button type="button" class="bulk-imports-hub__primary" @click="goToBankAccountsImport">
            Abrir carga
          </button>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import bulkImportService from '@/services/bulkImport.service'

export default {
  name: 'BulkImportsView',
  data () {
    return {
      isDownloadingTemplate: false
    }
  },
  methods: {
    async downloadTemplate () {
      if (this.isDownloadingTemplate) return

      this.isDownloadingTemplate = true
      try {
        const response = await bulkImportService.downloadBankAccountsTemplate()
        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'text/csv' })
        const fileUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = fileUrl
        link.download = 'plantilla_cuentas_bancarias.csv'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(fileUrl)
      } catch (error) {
        console.log(error)
      } finally {
        this.isDownloadingTemplate = false
      }
    },
    goToBankAccountsImport () {
      this.$router.push({ name: 'BulkImportBankAccounts' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.bulk-imports-hub {
  display: grid;
  gap: 1rem;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1rem 0 2rem;
}

.bulk-imports-hub__hero,
.bulk-imports-hub__card {
  padding: 1.1rem 1.2rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(255, 252, 247, 0.92), rgba(246, 239, 231, 0.9));
  box-shadow: 0 18px 42px rgba(43, 34, 24, 0.06);
}

.bulk-imports-hub__eyebrow,
.bulk-imports-hub__label {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(58, 46, 33, 0.48);
}

.bulk-imports-hub__title,
.bulk-imports-hub__item-title {
  margin: 0;
  color: #211913;
}

.bulk-imports-hub__copy,
.bulk-imports-hub__item-copy {
  color: rgba(45, 35, 26, 0.68);
  line-height: 1.7;
}

.bulk-imports-hub__card-head,
.bulk-imports-hub__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.bulk-imports-hub__actions {
  justify-content: flex-end;
}

.bulk-imports-hub__ghost,
.bulk-imports-hub__primary {
  min-height: 2.8rem;
  padding: 0 1rem;
  border-radius: 999px;
}

.bulk-imports-hub__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
}

.bulk-imports-hub__primary {
  border: 0;
  background: linear-gradient(135deg, #251d16 0%, #4c3c2d 100%);
  color: #f7f0e5;
}

@media (max-width: 760px) {
  .bulk-imports-hub__card-head {
    align-items: flex-start;
  }

  .bulk-imports-hub__actions {
    width: 100%;
    justify-content: stretch;
  }

  .bulk-imports-hub__ghost,
  .bulk-imports-hub__primary {
    width: 100%;
  }
}
</style>
